var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEfficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1334 5.26575L13.9157 4L8.45955 9.67574L9.67728 10.9415L15.1334 5.26575ZM18.7866 4L9.67298 13.4685L6.08434 9.73835L4.86661 11.0041L9.67298 16L20 5.26575L18.7866 4ZM0 11.0041L4.80637 16L6.0241 14.7343L1.21773 9.73835L0 11.0041Z",
    fill: "#84B0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficiency);
export default __webpack_public_path__ + "static/media/Efficiency.5a620e37e90015b1e05330154cd440e7.svg";
export { ForwardRef as ReactComponent };